import html2canvas from "html2canvas";
import { authHeaders } from "@/lib/leuteliaApi";

// Fotografa i grafici visibili a schermo (stessi che vede il direttore) per metterli nel PDF: nessun dato ricalcolato.
export async function captureCharts(max = 40) {
  const cards = Array.from(document.querySelectorAll('[data-testid^="chart-"]')).slice(0, max);
  const out = [];
  for (const el of cards) {
    const title = el.querySelector(".font-serif")?.textContent?.trim() || "";
    const sub = el.querySelector(".text-brand-muted")?.textContent?.trim() || "";
    try {
      const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", logging: false, useCORS: true });
      out.push({ title, sub, image: canvas.toDataURL("image/jpeg", 0.86), w: canvas.width, h: canvas.height });
    } catch { /* grafico non catturabile: il PDF esce comunque */ }
  }
  return out;
}

export async function downloadPdfWithCharts(url, filename, body, onProgress) {
  onProgress?.("Fotografo i grafici…");
  const charts = await captureCharts();
  onProgress?.("Impagino il PDF…");
  const res = await fetch(url, { method: "POST", headers: { ...authHeaders(), "Content-Type": "application/json" }, body: JSON.stringify({ ...body, charts }) });
  if (!res.ok) {
    let msg = `Errore ${res.status}`;
    try { msg = (await res.json()).detail || msg; } catch { /* no json */ }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  return charts.length;
}
